const messageMaker = (props, propName, compName, expectedType) => {
  return `Invalid prop '${propName}' of type '${typeof props[propName]}' supplied to '${compName}', expected type '${expectedType}'`;
};

const customProductIdValidator = (props, propName, compName) => {
  if (!props.isLoading && typeof props[propName] !== 'string') {
    return new Error(messageMaker(props, propName, compName, 'String'));
  }
};
export const productIdValidator = { isRequired: customProductIdValidator };

const customProductTypeValidator = (props, propName, compName) => {
  if (!props.isLoading && typeof props[propName] !== 'string') {
    return new Error(messageMaker(props, propName, compName, 'String'));
  }
};
export const productTypeValidator = { isRequired: customProductTypeValidator };

const customProductProfilesValidator = (props, propName, compName) => {
  if (!props.isLoading && !Array.isArray(props[propName])) {
    return new Error(messageMaker(props, propName, compName, 'Array'));
  }
};
export const productProfilesValidator = {
  isRequired: customProductProfilesValidator,
};

const customFormattedMessageValidator = (props, propName, compName) => {
  if (props.isLoading) {
    return;
  }
  if (typeof props[propName] !== 'object' || Array.isArray(props[propName])) {
    return new Error(messageMaker(props, propName, compName, 'FormattedMessage'));
  }
  const fmProps = props[propName].props || {};
  const keys = Object.keys(fmProps);
  const hasIdString = keys.includes('id') || typeof fmProps.id !== 'string';
  const hasDefaultMessageString = keys.includes('defaultMessage') || typeof fmProps.defaultMessage !== 'string';

  if (!hasIdString || !hasDefaultMessageString) {
    return new Error(messageMaker(props, propName, compName, 'FormattedMessage with id and defaultMessage'));
  }
};
export const formattedMessageValidator = {
  isRequired: customFormattedMessageValidator,
};
